import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Text from '@deprecated-ui/common/Text';
import Flex from '@deprecated-ui/common/Flex';
import Iconmoon from '@deprecated-ui/common/Iconmoon';
import Dropdown from '@deprecated-ui/watchlist/DropDown';
import EditWatchlist from './EditWatchlist';
import RemoveWatchlist from './RemoveWatchlist';
import MenuOverlay from './MenuOverlay';
import slice, { selectors, thunks } from './slice';

const { actions } = slice;

function DropdownMenu() {
  const dispatch = useDispatch();
  const { isDropdownOpen, needRefresh, modalVisible, activeWatchlistName } =
    useSelector(selectors);

  const dropdownToggle = (isOpen = !isDropdownOpen): void => {
    dispatch(actions.handleSetDropdown({ isOpen }));
  };

  useEffect(() => {
    dispatch(thunks.fetchSavedCompanyWatchlist({}));
  }, [dispatch]);

  useEffect(() => {
    if (needRefresh) {
      dispatch(thunks.fetchSavedCompanyWatchlist({}));
    }
  }, [dispatch, needRefresh]);

  return (
    <>
      <Dropdown
        width="280px"
        trigger={['click']}
        onVisibleChange={dropdownToggle}
        visible={isDropdownOpen}
        overlay={<MenuOverlay />}
        // @ts-expect-error
        destroyPopupOnHide
        zIndex={99}
      >
        <Flex align="center" style={{ cursor: 'pointer', gap: '10px' }}>
          <Text family="bold" weight="700">
            {activeWatchlistName}
          </Text>
          <Iconmoon className="icon-toolbar_down" />
        </Flex>
      </Dropdown>
      {modalVisible === 'edit' && <EditWatchlist />}
      {modalVisible === 'delete' && <RemoveWatchlist />}
    </>
  );
}

export default DropdownMenu;
